export enum ContactSourceE {
  UserRegister = 'user-register',
  UserImport = 'user-import',
  PlataformGroups = 'plataform-groups',
  PlataformRegister = 'plataform-register',
  WebLink = 'web_link',
  IntegrationPluga = 'integration-pluga',
  Call = 'call',
  PublicAPI = 'public-api',
}
